/**
 * Friendly "site is being set up / unknown tenant" page (FR-013).
 * Never enumerates valid tenants.
 */

export function TenantNotFound() {
  return (
    <div className="grid min-h-screen place-items-center bg-starz-off-white p-6">
      <div className="max-w-md text-center">
        <p className="mb-3 text-xs font-semibold uppercase tracking-widest text-starz-gold">
          Site not found
        </p>
        <h1 className="mb-4 font-serif text-4xl text-starz-navy">This site isn't set up yet.</h1>
        <div className="mb-6 h-0.5 w-14 bg-starz-gold" aria-hidden="true" />
        <p className="text-warm-gray">
          The contractor site you're looking for hasn't been configured here. If you believe this is
          a mistake, contact the contractor directly.
        </p>
      </div>
    </div>
  );
}
